export const couponCodeType = {
  GET_COUPON_LIST_REQUEST: "GET_COUPON_LIST_REQUEST",
  GET_COUPON_LIST_SUCCESS: "GET_COUPON_LIST_SUCCESS",
  GET_COUPON_LIST_FAIL: "GET_COUPON_LIST_FAIL",

  CREATE_COUPON_REQUEST: "CREATE_COUPON_REQUEST",
  CREATE_COUPON_SUCCESS: "CREATE_COUPON_SUCCESS",
  CREATE_COUPON_FAIL: "CREATE_COUPON_FAIL",

  COUPON_PLAYERS_PREVIEW_REQUEST: "COUPON_PLAYERS_PREVIEW_REQUEST",
  COUPON_PLAYERS_PREVIEW_SUCCESS: "COUPON_PLAYERS_PREVIEW_SUCCESS",
  COUPON_PLAYERS_PREVIEW_FAIL: "COUPON_PLAYERS_PREVIEW_FAIL",

  RESET_COUPON_PLAYERS_PREVIEW: "RESET_COUPON_PLAYERS_PREVIEW",

  GET_COUPON_PLAYERS_LIST_REQUEST: "GET_COUPON_PLAYERS_LIST_REQUEST",
  GET_COUPON_PLAYERS_LIST_SUCCESS: "GET_COUPON_PLAYERS_LIST_SUCCESS",
  GET_COUPON_PLAYERS_LIST_FAIL: "GET_COUPON_PLAYERS_LIST_FAIL"
};
